import {
	clearSelectedAccountant,
	clearSelectedClient,
	clearSelectedTaxYear,
	setAppBarSelectedItem,
} from "../../../store/actions";

import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export const AdminAccountantRoutesComponent = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const clearClientId = () => {
		dispatch(clearSelectedClient());
	};
	const clearClientName = () => {
		// dispatch(clearSelectedClientName());
		dispatch(clearSelectedClient());
	};
	const clearAccountantId = () => {
		dispatch(clearSelectedAccountant());
	};
	const clearAccountantName = () => {
		// dispatch(clearSelectedAccountantName());
		dispatch(clearSelectedAccountant());
	};
	const clearTaxYear = () => {
		dispatch(clearSelectedTaxYear());
	};
	const goToAccList = () => {
		dispatch(setAppBarSelectedItem({ appBarSelectedItem: "Accountant" }))
	};
	const goToHome = () => {
		dispatch(setAppBarSelectedItem({ appBarSelectedItem: "Home" }))
	};
	const ArrayData = [
		{
			label: "Home",
			// icon: <HomeOutlinedIcon />,
			expanded: true,
			items: [
				{
					label: "Client List",
					command: () => {
						navigate("/accountants/clients");
						clearClientId();
						clearClientName();
						clearTaxYear();
						// clearRefNo();
					},
				},
				{
					label: "Client Setup",
					// icon: <ContactMailOutlinedIcon />,
					command: () => {
						navigate("/clients/setup");
					},
				},
				{
					label: "Client Bank Setup",
					// icon: <ContactMailOutlinedIcon />,
					command: () => {
						navigate("/clients/bank-setup");
					},
				},
				{
					label: "Move Clients",
					// icon: <ContactMailOutlinedIcon />,
					command: () => {
						navigate("/clients/move-clients");
					},
				},
				{
					label: "Super User",
					command: () => {
						navigate("/accountants");
						clearClientId();
						clearClientName();
						clearAccountantId();
						clearAccountantName();
						clearTaxYear();
						goToAccList()
						// clearRefNo();
					},
				},
				{
					label: "Global Search",
					command: () => {
						navigate("/global-search");
						clearClientId();
						clearClientName();
						clearAccountantId();
						clearAccountantName();
						clearTaxYear();
						goToHome()
						// clearRefNo();
					},
				},
			],
		},
		// {
		// 	label: "Client Setup",
		// 	icon: <ContactMailOutlinedIcon />,
		// 	command: () => {
		// 		navigate("/clients/setup");
		// 	},
		// },
		// {
		//   icon: <ListAltOutlinedIcon />,
		//   label: "Adjustment Report",
		//       command: () => {
		//           navigate("/accountants/Client-adjustment-report")
		//       },
		// },
		// {
		//   label: "Move clients",
		//       command: () => {
		//           navigate("/accountants/move-clients")
		//       },
		// },
		//   {
		//     label: "Logout",
		//     icon: <LogoutOutlinedIcon />,
		//     command: () => {
		//         navigate("/logout")
		//     },
		//   },
	];
	return {
		AdminAccountantRoutes: ArrayData,
	};
};
